/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type QuizFormatDto = {
  /**
   * 퀴즈 아이템 타입 (MULTIPLE_CHOICE / TRUE_FALSE / SHORT_ANSWER / VOCABULARY).
   * 한 ContentPack은 하나의 itemType만 지원 (혼재 불가).
   */
  itemType: QuizFormatDto.itemType;
  /**
   * 선택지 수 (MULTIPLE_CHOICE일 때 필수, 2~5). 그 외 itemType에서는 무시.
   */
  choiceCount?: number;
};
export namespace QuizFormatDto {
  /**
   * 퀴즈 아이템 타입 (MULTIPLE_CHOICE / TRUE_FALSE / SHORT_ANSWER / VOCABULARY).
   * 한 ContentPack은 하나의 itemType만 지원 (혼재 불가).
   */
  export enum itemType {
    MULTIPLE_CHOICE = "MULTIPLE_CHOICE",
    TRUE_FALSE = "TRUE_FALSE",
    SHORT_ANSWER = "SHORT_ANSWER",
    VOCABULARY = "VOCABULARY",
  }
}
